import { render, staticRenderFns } from "./EncountersByDateChart.vue?vue&type=template&id=2275b68b&"
import script from "./EncountersByDateChart.vue?vue&type=script&lang=js&"
export * from "./EncountersByDateChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports